import {z} from 'zod';

export const SepaBankDetails = z.object({
  iban: z.string(),
  bic: z.string(),
  bankName: z.string(),
  bankCode: z.string(),
});

export type SepaBankDetails = z.infer<typeof SepaBankDetails>;
